import React from "react";
import moment from "moment-timezone";
import { map, isEmpty, values } from 'lodash';
import { formatToCurrency } from "../../../../Tools/formatToCurrency";

const communityRoleData = [
  {
    name: 'Board Member',
    value: 'board_member'
  },
  {
    name: 'Community Manager',
    value: 'community_manager'
  },
  {
    name: 'Concerned Resident',
    value: 'concerned_resident'
  },
];
const communityTypeData = [
  {
    name: 'Townhomes',
    value: 'townhomes'
  },
  {
    name: 'Detached Homes',
    value: 'detached'
  },
  {
    name: 'Condominium',
    value: 'condo'
  },
  {
    name: 'Apartment',
    value: 'apartment'
  },
];
const productServiceData = { pet_waste_stations: 'PWS', pet_waste_station_bags: 'PWS Bag', pet_waste_station_service: 'PWS Service', common_area_cleaning: 'Common Area Cleaning', trash_can_service: 'Trash Can Service', other:'Other' }

class DataTable {
  // format phone number
  formatPhoneNumber = (phone) => {
    phone = phone?.replace(/\D/g, '');
    return phone?.substr(0, 3) + ' ' + phone?.substr(3, 3) + ' ' + phone?.substr(6);
  }

  // convert date time from utc to local time
  UTCToLocal = (date) => {
    let stillUtc = moment.utc(date).toDate();
    return moment(stillUtc).local();
  }

  // convert date time from local to utc
  localToUTC = (date) => {
    return moment.utc(date)
  }

  // proposal columns
  proposalColumns = () => {
    return ([
      {
        title: 'Proposal Number',
        dataIndex: 'number',
        key: 'number',
        sorter: false,
        className: 'tname',
        render: (text, record) => <span>{record?.proposal_number || ''}</span>
      },
      {
        title: 'Community Name',
        dataIndex: 'hoa',
        key: 'hoa',
        sorter: false,
        className: 'tname',
        render: (text, record) => <span className="ellipse">{record?.community_name ? record?.community_name : '-'}</span>
      },
      {
        title: 'Community Manager',
        dataIndex: 'community_manager',
        key: 'community_manager',
        sorter: true,
        className: 'tadd',
        render: (text, record) => 
          <span className="ellipse">{record?.first_name ? `${record?.first_name} ${record?.last_name}` : '-'}</span>
      },
      {
        title: 'Community Role',
        dataIndex: 'community_role',
        key: 'community_role',
        sorter: false,
        className: 'tadd',
        render: (text, record) => {
          const idx = communityRoleData.findIndex(obj => obj.value === record?.role)
          return <span className="ellipse">{idx > -1 ? communityRoleData[idx].name : '-'}</span>
        }
      },
      {
        title: 'Property Type',
        dataIndex: 'property_type',
        key: 'property_type',
        sorter: false,
        className: 'tadd',
        render: (text, record) => {
          // const idx = communityTypeData.findIndex(obj => obj.value === record?.properties_in_community)
          const filteredArray = communityTypeData.filter(value => record?.properties_in_community?.includes(value.value));
          return <span className="ellipse">{filteredArray.map(x => x.name).join(",")}</span>
        }
      },
      {
        title: 'Phone Number',
        dataIndex: 'phone_numbers__phone',
        key: 'phone_numbers__phone',
        sorter: true,
        className: 'tphnum',
        render: (text, record) => {
          let phone_numbers = '';
          !isEmpty(record?.phone_numbers) && map(record?.phone_numbers, (item) => {
            phone_numbers = item?.primary && item?.phone;
          })

          return <span>{!isEmpty(record?.phone_numbers) ? phone_numbers ? `+1 ${this.formatPhoneNumber(phone_numbers)}` : `+1 ${this.formatPhoneNumber(record?.phone_numbers?.[0]?.phone)}` : ''}</span>
        }
      },
      {
        title: 'Email Address',
        dataIndex: 'email_address',
        key: 'email_address',
        sorter: true,
        render: (text, record) => <span className="ellipse">{record?.email_address || '-'}</span>
      },
      {
        title: 'Management Company',
        dataIndex: 'management_company',
        key: 'management_company',
        sorter: true,
        render: (text, record) => <span className="ellipse">{record?.management_company || '-'}</span>
      },
      {
        title: 'Proposal Date',
        dataIndex: 'proposal_date',
        key: 'proposal_date',
        sorter: false,
        className: 'tdate',
        render: (text, record) => {
          return <span className="ellipse">{record?.is_looking_for_proposal && record?.proposal_due ? this.UTCToLocal(record?.proposal_due).format('MMM DD, YYYY') : '-'}</span>
        }
      }, {
        title: 'Looking For',
        dataIndex: 'proposal_date',
        key: 'proposal_date',
        sorter: false,
        className: 'tdate',
        render: (text, record) => {
          return <span className="ellipse">{record?.is_looking_for_proposal ? 'Proposal' : record?.would_like_more_info ? 'More Info' : '-'}</span>
        }
      },
      // {
      //   title: 'Probability',
      //   dataIndex: 'probability',
      //   key: 'probability',
      //   sorter: false,
      //   className: 'tdate',
      //   render: () => <span className="ellipse">{}</span>
      // }
    ]);
  }

  // customer columns
  customerColumns = (franchiseList) => {
    return ([
      {
        title: 'Acc Number',
        dataIndex: 'acc_number',
        key: 'acc_number',
        sorter: false,
        className: 'tname',
        render: (text, record) => <span>{record?.account_number}</span>
      },
      {
        title: 'HOA',
        dataIndex: 'hoa',
        key: 'hoa',
        sorter: true,
        className: 'tname',
        render: (text, record) => <span className="ellipse">{record?.community_name}</span>
      },
      {
        title: 'Community Manager',
        dataIndex: 'commercial_community_manager',
        key: 'commercial_community_manager',
        sorter: true,
        className: 'tadd',
        render: (text, record) => <span className="ellipse">{`${record?.first_name} ${record?.last_name}`}</span>
      },
      {
        title: 'Phone Number',
        dataIndex: 'phone_numbers__phone',
        key: 'phone_numbers__phone',
        sorter: true,
        className: 'tphnum',
        render: (text, record) => {
          let phone_numbers = '';
          !isEmpty(record?.phone_numbers) && map(record?.phone_numbers, (item) => {
            phone_numbers = item?.primary && item?.phone;
          })

          return <span>{!isEmpty(record?.phone_numbers) ? phone_numbers ? `+1 ${this.formatPhoneNumber(phone_numbers)}` : `+1 ${this.formatPhoneNumber(record?.phone_numbers?.[0]?.phone)}` : ''}</span>
        }
      },
      {
        title: 'Management Company',
        dataIndex: 'commercial_profile__management_company',
        key: 'commercial_profile__management_company',
        sorter: true,
        className: 'tphnum',
        render: (text, record) => <span className="ellipse">{record?.management_company || ''}</span>
      },
      {
        title: 'Franchise',
        dataIndex: 'franchise',
        key: 'franchise',
        sorter: false,
        filters: franchiseList,
        className: 'lfbdr tprofile filterico',
        filterIcon: <i className="las la-filter" />,
        render: (text, record) => !isEmpty(record?.field_office) ?
          <span>{`${record?.field_office?.name}`}</span> : ''
      },
      {
        title: 'Product/Service',
        dataIndex: 'service',
        key: 'service',
        sorter: false,
        className: 'tname',
        render: (text, record) => {
          const product_or_service = record?.product_or_service?.map(x => productServiceData[x?.item]) || []
          return <span className="wrap">{`${[...product_or_service]?.join(', ')}`}</span>
        }
      },
      {
        title: 'Joined',
        dataIndex: 'joined',
        key: 'joined',
        sorter: false,
        className: 'tdate',
        render: (text, record) => {
          return <span>{this.UTCToLocal(record?.created_at).fromNow(true)}</span>
        }
      },
      {
        title: 'Outstanding',
        dataIndex: 'outstanding',
        key: 'outstanding',
        sorter: false,
        className: 'tname',
        render: (text, record) => <span><b>{`$${formatToCurrency(record?.customer_open_invoice_balance)}`}</b></span>
      },
      {
        title: 'Satisfaction',
        dataIndex: 'satisfaction',
        key: 'satisfaction',
        sorter: false,
        className: 'tname',
        render: () => <span>{ }</span>
      },
      {
        title: 'Next follow up',
        dataIndex: 'next_follow_up',
        key: 'next_follow_up',
        sorter: false,
        className: 'tdate',
        render: (text) => <span>{text ? moment(text).format('MMM DD, YYYY') : ''}</span>
      },
      {
        title: 'Status',
        dataIndex: 'suspend',
        key: 'suspend',
        sorter: false,
        className: 'tdate',
        render: (text, record) => <span>{record?.is_active ? <b className="success">Active</b> : <b className="danger">Inactive</b>}</span>
      }
    ]);
  }

}

export default new DataTable();
